module.exports = __webpack_public_path__ + "img/empty-image.0424eee4.png";